import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Collapse } from "../utils/Collapse";
import { Container, HeaderRow } from "./styles";
import { isTest } from "./types";
/**
 * A collapsible drawer component.
 *
 * @param {DrawerProps} props The props for the component.
 * @returns {JSX.Element} The rendered drawer component.
 */
export const Drawer = ({ children, isOpened = false, collapsible = true, disableAnimation = false, header, onToggle = (_isOpened) => { }, testId, }) => (_jsxs(Container, { className: "drawer-container", tabIndex: 0, onKeyDown: collapsible
        ? (event) => {
            // NOTE: Test environment does not handle the current focus element (activeElement)
            const drawerIsFocused = isTest || event.currentTarget === document.activeElement;
            if (drawerIsFocused) {
                if (event.keyCode === 32 /* Space */) {
                    onToggle(!isOpened);
                }
                else if (event.key === "ArrowDown" && !isOpened) {
                    onToggle(true);
                }
                else if (event.key === "ArrowUp" && isOpened) {
                    onToggle(false);
                }
            }
        }
        : undefined, "data-test-id": testId, children: [_jsx(HeaderRow, { collapsible: collapsible, onClick: collapsible
                ? () => {
                    onToggle(!isOpened);
                }
                : undefined, children: header }), _jsx(Collapse, { isOpened: isOpened, disableAnimation: disableAnimation, children: children })] }));
